<template>
    <section v-if="showReminderNotification" id="ReminderNotification"
    class="flex justify-between gap-2 items-center h-[60px] w-full bg-[#EC2B2B] px-3"
    :style="`border-radius: 7px;background: ${notificationData?.type == 'verification_accepted' || notificationData?.type == 'store_verification_expiration' ? 'linear-gradient(14deg, #080451 1%, #0d0d83 49%, #163761 93%, #163761) !important' : ''}`">
        <p class="text-white sm:text-base text-xs ">
            {{ notificationData?.body || 'No notification available' }}
        </p>
        <div class="flex justify-between sm:gap-6 gap-2 items-center w-fit">
            <button
                class="bg-white hover:bg-slate-100 rounded-[0.813rem] text-[#EC2B2B] font-semibold sm:text-xs text-[0.5rem]  py-[.4rem] px-5  text-center"
                @click="handleRenew">
                {{ notificationData?.type == 'verification_accepted' ? $t('general.verify_now') : $t('general.renew_now') }}
            </button>
            <button @click="handleCloseNotification" class="w-5 hover:scale-90 duration-100">
                <img src="@/assets/images/close.svg" class=" " alt="">
            </button>
        </div>
        <div v-if="handleRenewClicked === true" class="absolute inset-0 flex justify-center items-center">
            <div class="inset-0 z-[110] w-full bg-[#2b2b2b8e]">
                <transition name="dropdown">
                <!-- modal contnet-->
                <div
                    class="fixed left-[50%] top-[50%] z-[120] flex w-[90%] max-w-[400px] translate-x-[-50%] translate-y-[-50%] flex-col gap-8 overflow-hidden rounded-lg bg-gray-200 px-3 py-3 sm:w-full"
                    style=""
                >
                    <h1
                    autofocus="false"
                    aria-selected="false"
                    class="mx-auto w-full border-b-2 border-[#000000] px-1 py-2 text-center font-extrabold text-[#000000] [font-size:_clamp(.7em,2vw,1em)] sm:w-[70%]"
                    >
                    {{ $t("general.choose_payment_method") }}
                    </h1>
                    <section class="mt-5 grid gap-6">
                    <!-- Card -->
                    <div class="relative">
                        <input v-model="paymentMethod" value="card" class="peer hidden" id="radio_1" type="radio" name="radio" checked />
                        <label
                        class="flex cursor-pointer select-none rounded-lg border border-gray-400 p-4 peer-checked:border-2 peer-checked:border-[#4f55f2] peer-checked:bg-gray-50"
                        for="radio_1"
                        >
                        <img class="w-14 object-contain" src="@/assets/upgrade/visa.png" alt="" />
                        <div class="mr-5 ltr:ml-5 ltr:mr-0">
                            <span class="mt-2 font-semibold [font-size:_clamp(.7em,2vw,1em)]">{{ $t("general.by") }}</span>
                            <p class="text-sm leading-6 text-slate-500">Visa</p>
                        </div>
                        </label>
                    </div>

                    <!-- Mobile wallet -->
                    <div class="relative">
                        <input v-model="paymentMethod" value="mobile_wallet" class="peer hidden" id="radio_2" type="radio" name="radio" @change="logPaymentMethod" />
                        <label
                        class="flex cursor-pointer select-none rounded-lg border border-gray-400 p-4 peer-checked:border-2 peer-checked:border-[#4f55f2] peer-checked:bg-gray-50"
                        for="radio_2"
                        >
                        <img class="w-14 object-contain" src="@/assets/upgrade/wallet.png" alt="" />
                        <div class="mr-5 ltr:ml-5 ltr:mr-0">
                            <span class="mt-2 font-semibold [font-size:_clamp(.7em,2vw,1em)]">{{ $t("general.by") }}</span>
                            <p class="py-2 text-sm leading-6 text-slate-500">Mobile wallet</p>
                        </div>
                        </label>
                    </div>
                    <!-- phone input for mobile wallet -->
                    <div v-if="this.paymentMethod === 'mobile_wallet'">
                        <input
                        v-model="phone"
                        maxlength="11"
                        type="tel"
                        @input="(e) => (phone = e.target.value.replace(/\D/g, ''))"
                        :class="`mt-2 w-full bg-[#FFFFFF] ${v$.phone ? (v$.phone.$errors.length ? 'border-[#ed0d0d]' : 'border-[#D8D8D8]') : 'border-[#D8D8D8]'} block rounded-[7px] border p-2.5 pr-3 text-sm text-gray-900 outline-none placeholder:text-[#bebebe] focus:border-blue-500 ltr:text-inherit rtl:text-end`"
                        :placeholder="$t('user.store.phone_number')"
                        />
                        <p v-for="(error, index) of (v$?.phone?.$errors || [])" :key="error.uid" class="mt-1 pr-2 text-sm text-red-600 ltr:pl-2 ltr:pr-0">
                        {{ index == 0 ? error.$message : "" }}
                        </p>
                    </div>

                    <!-- Cezma wallet- credit wallet -->
                    <div class="relative">
                        <input v-model="paymentMethod" value="credit_wallet" class="peer hidden" id="radio_3" type="radio" name="radio" />
                        <label
                        class="flex cursor-pointer select-none rounded-lg border border-gray-400 p-4 peer-checked:border-2 peer-checked:border-[#4f55f2] peer-checked:bg-gray-50"
                        for="radio_3"
                        >
                        <svg xmlns="http://www.w3.org/2000/svg" width="56px" height="56px" viewBox="0 0 48 48">
                            <g fill="none">
                            <rect
                                width="38"
                                height="26"
                                x="5"
                                y="13"
                                fill="#2f88ff"
                                stroke="#000"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="4"
                                rx="2"
                            />
                            <rect width="18" height="11" x="25" y="20" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="4" />
                            <path stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="4" d="M43 18L43 33" />
                            <path
                                stroke="#000"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="4"
                                d="M32 13C32 8 28.5 7 27 7C23.6667 7 16.1 7 12.5 7C8.9 7 8 9.86567 8 11.2985V13"
                            />
                            <circle cx="33.5" cy="25.5" r="1.5" fill="#fff" />
                            </g>
                        </svg>
                        <div class="mr-5 ltr:ml-5 ltr:mr-0">
                            <span class="mt-2 font-semibold [font-size:_clamp(.7em,2vw,1em)]">{{ $t("general.by") }}</span>
                            <p class="py-2 text-sm leading-6 text-slate-500">Cezma wallet</p>
                        </div>
                        </label>
                    </div>

                    
                    </section>

                    <section class="flex flex-row justify-around font-semibold text-white [font-size:_clamp(.7em,2vw,.9em)]">
                    <button
                        @click="checkout"
                        :disabled="isProcessing"
                        class="w-[80%] rounded-md bg-[#0963FF] px-1 py-2 text-center hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-200 disabled:bg-blue-900 dark:focus:ring-blue-900 sm:w-[40%]"
                    >
                        {{ isProcessing ? $t("general.loading") : ` ➔ ${$t("general.continue_payment")}` }}
                    </button>
                    <!-- New close button -->
                    <button
                        @click="closePopup"
                        class="w-[30%] rounded-md bg-red-500 px-1 py-2 text-center hover:bg-red-700 focus:outline-none"
                    >
                        {{ $t("general.close") }}
                    </button>
                    <!-- <button class="bg-[#0963FF] py-2 px-1 w-[30%] text-center rounded-md">تخطي الكل</button> -->
                    </section>
                </div>
                </transition>
            </div>
        </div>
    </section>
</template>
<script>
import { useGlobalStore } from "@/store/Modules/global.js";
import PaymentComponent from "./PaymentComponent.vue";
// Import your validation library here
import { useVuelidate } from '@vuelidate/core'; // Example import
import { Modal } from '@/components';
export default {
    name: "ReminderNotification",
    props: {
        notificationData: {
            type: Object,
            required: false,
            default: {}
        },
    },
    components:{
        PaymentComponent,
        Modal
    },
    emits: ['openRenewModal'],
    setup() {
        const global = useGlobalStore();
        const v$ = useVuelidate(); // Initialize validation

        return {
            global,
            v$, // Return the validation object
        };
    },
    data() {
        return {
            showReminderNotification: false,
            isProcessing: false,
            handleRenewClicked: false,
            paymentMethod: 'card', // Default payment method
            phone: '', // Phone number for mobile wallet
        };
    },
    methods: {
        logPaymentMethod() {
        },
        handleCloseNotification() {
            this.showReminderNotification = false;
            this.notificationsHaveBeenRead();
        },
        handleRenew() {
            if (this.notificationData.type == 'verification_accepted' || this.notificationData.type == 'store_verification_expiration') {
                this.handleRenewClicked = true;
            } else {
                if (!this.notificationData?.type_id) {
                    this.notify({ type: 'error', msg: this.$t('general.failed') });
                    return;
                }
                this.$emit('openRenewModal', {
                    storeId: this.notificationData.type_id,
                    notification: this.notificationData,
                });
            }
        },
        closePopup(){
            this.handleRenewClicked = false;
        },
        checkout(){
            const formData = new FormData();
            formData.append('payment_method', this.paymentMethod);
            formData.append('phone', this.phone);
            formData.append('store_id', this.notificationData.type_id);
            const formDataObj = Object.fromEntries(formData.entries());
            this.makeRequest({
                owner: this.MAINROLES.user,
                url: this.notificationData.type == 'verification_accepted' ? 
                this.APIREQUESTS.user.verifyPay.url : 
                this.APIREQUESTS.user.renewVerificationPay.url,
                method: this.notificationData.type == 'verification_accepted' ? 
                this.APIREQUESTS.user.verifyPay.method : 
                this.APIREQUESTS.user.renewVerificationPay.method,
                
                formData: formDataObj
            }).then((res)=>{
                this.notify({type:"success",msg:res?.data?.message});
                this.handleRenewClicked = false;
                if(res?.data?.payment_url != null){
                    window.open(res?.data?.payment_url, '_blank');
                    this.$router.go(0);
                }else{
                    if(res?.status){
                        this.notify({type:"success",msg: res?.message || this.$t("general.success")});
                        this.$router.go(0);
                    }else{
                        this.notify({type:"error",msg: res?.message || this.$t("general.failed")});
                    }
                }
            }).catch((err)=>{
                this.notify({type:"error",msg: err?.message || this.$t("general.failed")});
                this.handleRenewClicked = false;
            }).finally(()=>{

            })
        },
        
        notificationsHaveBeenRead() {
            this.makeRequest({
                owner: this.MAINROLES.user,
                url: `${this.APIREQUESTS.user.notifications.url}/read`,
                method: 'POST',
                formData: {
                    notification_ids: [this.notificationData.id]
                }
            })
                .then((res) => {
                    if (!res?.status) return
                    //handle the case of success and notifcation not updated in home page savedData in state management 
                    //so when user goto any page and go back how will find notification still there beacuse its not updated
                    // let editedData=this.global.savedHomepageData.receivedData.data
                    // editedData={
                    //     ...editedData,
                    //     notification:null
                    // }
                    // this.global.updateHomepageData({
                    //     receivedData: { 
                    //         ...this.global.savedHomepageData.receivedData, 
                    //         ...{ data: editedData} 
                    //     }
                    // });
                })
                .catch((err) => {
                    this.notify({ type: 'error', msg: err?.data?.message })
                    this.showReminderNotification = true
                })
                .finally(() => {
                });
        },
    },
    mounted() {
        if (this.notificationData) {
            if(this.notificationData.type === 'warning'){
                return;
            }else{
                this.showReminderNotification = true; // Set to true only if there's notification data
            }
        }
    },
};
</script>

<style scoped>
#staticModal {
    position: fixed;
    inset: 0;
    max-height: 100vh;
    max-height: 100svh;
    width: 100%;
    z-index: 150;
}
</style>
